import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeartPulse, faLocationDot, faHeart } from "@fortawesome/free-solid-svg-icons";
import NavbarLogo from "../../components/Navbar/csdv2Logo.png";

// Automatically import all images from assets/ourkids
const importAll = (r) => r.keys().map(r);
const kidsImages = importAll(require.context("../../assets/ourkids", false, /\.(png|jpe?g|svg|webp)$/));
const KIDS = kidsImages.map((img) => ({ img }));

const OurKids = () => {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      {/* Hero Section */}
      <section className="relative py-32 gradient-bg text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white to-transparent" />
        <div className="container mx-auto px-6 text-center relative z-10">
          <h1 className="text-5xl md:text-8xl font-black mb-6 tracking-tighter flex flex-col md:flex-row items-center justify-center gap-6">
            <img src={NavbarLogo} alt="Logo" className="hidden md:block md:h-32 w-auto" />
            <span>Brave <span className="italic opacity-80">Hearts</span></span>
          </h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto font-light opacity-90 leading-relaxed">
            These are the faces of resilience. Children who fought against CHD and won, thanks to your support.
          </p>
        </div>
      </section>

      {/* Intro Text */}
      <section className="py-24 bg-white border-b border-brand-beige italic">
        <div className="container mx-auto px-6 text-center font-medium">
          <p className="text-2xl text-slate-600 max-w-4xl mx-auto leading-relaxed">
            "Every child deserves a life full of possibilities. We are honored to have played a part in ensuring these beautiful hearts continue to beat."
          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-24">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12">
            {KIDS.map((kid, i) => (
              <div key={i} className="group cursor-pointer">
                <div className="relative overflow-hidden rounded-[3rem] shadow-2xl aspect-[4/3] bg-slate-900">
                  <img
                    src={kid.img}
                    alt={`Super Kid ${i + 1}`}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 opacity-90 group-hover:opacity-100"
                  />
                  {/* Overlay on hover */}
                  <div className="absolute inset-0 bg-brand-red/80 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center p-8 text-center text-white">
                    <div className="relative z-10">
                      <FontAwesomeIcon icon={faHeartPulse} size="3x" className="mb-4 animate-pulse" />
                      <p className="font-black text-[14px] uppercase tracking-tighter mb-2 leading-none">Shishu Hriday with little hearts </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Help Banner */}
      <section className="py-32 bg-slate-900 text-white text-center">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl md:text-5xl font-black tracking-tighter mb-8 max-w-2xl mx-auto leading-tight italic opacity-90">
            many more children are <span className="text-brand-red">waiting for a secound chance.</span>
          </h2>
          <p className="text-slate-400 mb-12 max-w-xl mx-auto font-medium">Your donation provides the best chance for a child born with CHD.</p>
          <Link to="/donate-now" className="inline-block px-12 py-5 gradient-bg text-white rounded-full font-black text-xl hover-glow transform hover:scale-105 transition-all shadow-2xl uppercase tracking-tighter">
            Support a child <FontAwesomeIcon icon={faHeart} className="ml-2" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default OurKids;